/**
 * THE website's free-tier allowance. One definition, 2026-09-15.
 *
 * Until today there were TWO constants named FREE_LIMITS in this codebase and
 * they disagreed:
 *   - this file said 1/1/1/1 and is what the USER IS TOLD (PremiumFeatureModal
 *     renders these numbers, GaragePage gates the garage on them);
 *   - src/context/AppContext.tsx declared its own shadowing copy at 2/1/3/1
 *     and is what ACTUALLY GATES assessments, Car Lens and Ask (AppContext
 *     :462-497).
 * So the upgrade modal told people they had 1 assessment while the gate let
 * them take 2, and told them 1 Ask question while the gate allowed 3.
 *
 * Resolved by adopting the ENFORCED numbers here and deleting the shadow, so
 * nobody's access changes — only the message becomes true. Picking different
 * numbers is a monetization decision and belongs to the founder, not to a
 * copy fix.
 *
 * NOTE, AND IT IS NOT RECONCILED: the mobile app is a THIRD set of numbers.
 * carsjudge/hooks/useUsageLimits.ts:18 has ASSESSMENT 3 lifetime, CAR_LENS 3
 * lifetime, CHAT 2 PER DAY. The comment that used to sit above the shadow in
 * AppContext claimed it "matches mobile app (useUsageLimits.ts)" — it never
 * did. Web and app genuinely give different free allowances; whether they
 * should match is the founder's call.
 *
 * Cadence: these are LIFETIME caps on the web, not monthly. Nothing in this
 * codebase resets them. Do not write "per month" in copy that references them.
 */
export const FREE_LIMITS = {
  ASSESSMENTS: 2,
  CAR_LENS: 1,
  ASK_CARSJUDGE: 3,
  GARAGE_CARS: 1,
} as const;

export type LimitType = 'assessment' | 'carlens' | 'askcarsjudge' | 'garage' | null;
